const ReviveVoices = () => {
	const block = document.querySelectorAll(".revive-voices");
	if (!block) {
		return;
	}
	block.forEach((element) => {
		const controls = element.querySelectorAll(".revive-voices__item-control");
		const items = element.querySelectorAll(".revive-voices__item");
		const card = element.querySelector(".revive-voices__card");
		const urlParams = new URLSearchParams(window.location.search);

		controls.forEach((control) => {
			control.addEventListener("click", (e) => {
				const parent = e.target.closest(".revive-voices__item");
				if (!parent.classList.contains("active")) {
					items.forEach((item) => {
						item.classList.remove("active");
					});
					parent.classList.add("active");

					card.classList.add("active");
					card.querySelector(".revive-voices__card-title").textContent = e.target.getAttribute("data-title");
					card.querySelector(".revive-voices__card-label").textContent = e.target.getAttribute("data-date");
					card.querySelector(".revive-voices__card-image-i").setAttribute("src", e.target.getAttribute("data-image"));

					
					urlParams.set("artist", e.target.getAttribute("data-title").replace(/ /g, "_"));
					history.replaceState(null, null, "?" + urlParams.toString());
				}
			});
		});

		const clearVotes = () => {
			items.forEach((item) => {
				item.classList.remove("active");
			});
		};

		document.addEventListener("hbspt-form-revive-submit", (e) => {
			element.classList.add("submitted");
			clearVotes();
		});

		let cloned = false;
		const handleListPosition = () => {
			const frame = element.querySelector(".revive-voices__box-preview");
			const list = element.querySelector(".revive-voices__list");
			const body = element.querySelector(".revive-voices__body");
			const ww = window.innerWidth;

			if (ww > 767) {
				if (cloned) {
					body.append(element.querySelector(".revive-voices__list"));
					cloned = false;
				}
			} else {
				if (!cloned) {
					frame.prepend(list);
					cloned = true;
				}
			}
		}

		handleListPosition();
		window.addEventListener("resize", (e) => {
			handleListPosition();
		});
	});
};

export default ReviveVoices;
